import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ResetForm from './Layout/ResetForm';
import Wrapper from './Layout/Wrapper';

class Reset extends Component{

    render(){
        const { alert: { reset }, url } = this.props;
        return (
            <Wrapper>
                {reset !== false && 
                    <Alert color={reset.type}>
                        {reset.message}
                        {reset.type === 'success' && 
                            <div><Link to='/'>Login</Link></div>
                        }
                    </Alert>    
                }
                <ResetForm url={url}/>
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    alert: state.auth.alert,
});

export default connect(mapStateToProps)(Reset);


// WEBPACK FOOTER //
// ./src/Components/Auth/Reset.js